import React from "react";
import { FirstScreen } from "../components/FirstScreen/FirstScreen";
import { ProductsGrid } from "../components/ProductsGrid/ProductsGrid";
import { ProductSlider } from "../components/ProductSlider/ProductSlider";
import { NftDefaultValue } from "../defalult/NftDefaultValue";
import FireICon from "../assets/img/icons/fire.svg";
import Diamond from "../assets/img/icons/diamond.svg";
import { CollectionDefaultValue } from "../defalult/CollectionDefaultValue";
import { TopCreators } from "../components/TopCreators/TopCreators";
import { CreatorDefaultValue } from "../defalult/CreatorDefaultValue";
import { JoinCommunity } from "../components/JoinCommunity/JoinCommunity";

const NftSlider = NftDefaultValue.slice(0, 8);
const Nfts = NftDefaultValue;
const Collections = CollectionDefaultValue;
const Creators = CreatorDefaultValue;

export const MainPage = () => {
  return (
    <>
      <FirstScreen />
      <ProductSlider products={NftSlider} title={"Hot Drops"} titleIcon={FireICon} />
      <ProductSlider products={Collections} title={"Hot Collections"} titleIcon={Diamond} collection={true} />
      <TopCreators creators={Creators} />
      <ProductsGrid products={Nfts} title='Explore' showButton={true} />
      <JoinCommunity />
    </>
  );
};
